import { PrimaryColors } from '../../../../colors/primaryColors/primaryColors/index.js';

const selectionStyles = `
  ::-moz-selection {
      background-color: ${PrimaryColors.base.default};
      color: ${PrimaryColors.text.default};
  }
  ::selection {
      background-color: ${PrimaryColors.base.default};
      color: ${PrimaryColors.text.default};
  }
`;

export { selectionStyles };
